module.exports = function (string) {
  return string.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&")
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/regexp-quote/regexp-quote.js
// module id = 331
// module chunks = 0